<template>
  <vx-card class="ticket-detail main-box top-zero-radius md:w-3/4 mx-auto">
    <div class="ticket-detail-profile">
      <div class="general-info" :class="{'is-mobile': isMobile}">
        <div class="general-info-items">
          <h1 class="subject">
            {{ ticket.subject }}
          </h1>
<!--          <div class="general-info-item">
            {{ $t('tickets.detail.labels.ticketId') }}
            {{ ticket.id }}
          </div>-->
          <div class="general-info-item">
            {{ ticket.department }}
          </div>
          <div v-if="/*$store.state.auth.user.id === creatorInfo.id && */ticket.status !== 4" class="general-info-item">
            <button class="complete-btn" @click="completeTicket">
              {{ $t('tickets.detail.labels.setComplete') }}
            </button>
          </div>
        </div>
        <div class="general-info-items left">
          <div class="general-info-item">
          <span class="label">
          {{ $t('tickets.detail.labels.status') }}
          </span>
            <span class="content">
            {{ statusTypes[ticket.status] }}
          </span>
          </div>
          <div class="general-info-item">
          <span class="label">
          {{ $t('tickets.detail.labels.createdAt') }}
          </span>
            <span class="content date">
            {{ ticket.date }}
          </span>
          </div>
          <div class="general-info-item">
          <span class="label">
          {{ $t('tickets.detail.labels.lastUpdate') }}
          </span>
            <span class="content">
            {{ ticket.lastUpdate }}
          </span>
          </div>
        </div>
      </div>
      <div class="message-section">
        <template v-for="(message, key) in ticket.messages">
          <div :key="key" class="message" :class="{'client': message.client}">
            <div class="user-avatar">
              <img :src="message.userAvatar" :alt="message.creator" loading="lazy" class="user-image">
            </div>

            <div class="message-body">
              <h2 class="message-header">
              <span class="user-name">
                {{ message.creator }}
              </span>
                |
                <span class="user-company">
              {{ message.company }}
            </span>
              </h2>
              <p class="message-text">
                <vue-markdown>
                  {{ message.body }}
                </vue-markdown>
              </p>

              <div v-if="message.attaches.length > 0" class="attach-list">
                <template v-for="(attach, attach_key) in message.attaches">
                  <a :key="`${key}_${attach_key}`" :href="attach.link" target="_blank" class="attach-link">
                    <custom-icon icon="file-export-icon" :color-code="message.client ? '#000' : '#fff'" height="20px" width="20px" />
                    <span class="attach-name">
                    {{ attach.name }}
                  </span>
                  </a>
                </template>
              </div>
            </div>
            <div class="message-date">
              <span class="time">{{ message.time }}</span>
              <span class="date">{{ message.date }}</span>
            </div>
          </div>
        </template>
      </div>
      <div id="showLastMessage"></div>
    </div>

    <div class="ticket-detail-answer" v-if="ticket.status !== 4 && $u.checkPermissions('ticket.create')">
      <answer-support-ticket  @insert="handleReloadTicket" />
    </div>

    <vs-button id="sendMessageTicketBTN"
               v-show="false"
               v-if="$u.checkPermissions('ticket.create')"
               @click="$refs.sendConfirmation.showDialog()">
    </vs-button>

    <custom-dialog ref="sendConfirmation"
                   :title="$t('tickets.general.confirmations.send.title')"
                   :body="$t('tickets.general.confirmations.send.body')"
                   @accept="sendMessageTicket"/>


    <button v-show="false"
            id="answerTicket"
            @click="answerTicketPromptStatus = true"/>
  </vx-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment-jalaali'
import VueMarkdown from 'vue-markdown'
import CustomIcon from '@/components/icon/customIcon'
import {
  completeTicket,
  getTicket,
  sendTicketToService
} from '@/http/requests/tickets'
import AnswerSupportTicket from './answer/AnswerTicket.vue'
import CustomDialog from '@/components/dialog/customDialog'

export default {
  name: 'TicketDetail',
  metaInfo () {
    return {
      title: this.$t('tickets.detail.title')
    }
  },
  components: {CustomDialog, AnswerSupportTicket, CustomIcon, VueMarkdown},
  data () {
    return {
      answerTicketPromptStatus: false,
      statusTypes: {
        0: this.$t('tickets.general.statusTypes.created'),
        1: this.$t('tickets.general.statusTypes.portalResponse'),
        2: this.$t('tickets.general.statusTypes.appResponse'),
        3: this.$t('tickets.general.statusTypes.pending'),
        4: this.$t('tickets.general.statusTypes.completed')
      },
      operatorInfo: {
        id: 0,
        name: ''
      },
      creatorInfo: {
        id: 0,
        name: ''
      },
      ticket: {
        id: null,
        subject: '',
        department: '',
        status: 4,
        date: '',
        lastUpdate: '',
        messages: []
      },
      actions: [
        {
          toolbar: [],
          leftToolbar: [
            {
              id: 'routeBackBTN',
              route: {name: 'tickets'},
              icon: 'chevron-left-icon',
              iconPack: 'useral'
            }
          ]
        }
      ]
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.windowWidth < this.$store.state.mobileScreen
    }
  },
  created () {
    // this.$vs.loading()
    this.$nextTick(() => {
      this.$store.dispatch('updateNavbarActions', this.actions[0])
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
      this.$store.dispatch('updateContentNavbarClass', ' md:w-3/4 mx-auto')
    })

    this.getTicket()
  },
  methods: {
    getTicket () {
      getTicket(this.$route.params.id, true).then((response) => {
        const ticket = response.data.data
        this.ticket.id = ticket.id
        this.ticket.date = this.$u.convertUtcToLocale(ticket.started_at, this.$u.locale.validator('moment.dateTime'))
        this.ticket.subject = ticket.subject
        this.ticket.status = ticket.status
        this.ticket.lastUpdate = moment(ticket.answered_at, this.$u.locale.validator('moment.dateTime')).locale(this.$i18n.locale).fromNow()

        this.creatorInfo = {
          id: ticket.creator ? ticket.creator.id : 0,
          name: ticket.creator ? `${ticket.creator.name || ''} ${ticket.creator.family || ''}` : this.$t('tickets.general.labels.unknown')
        }

        // let actions = JSON.parse(JSON.stringify(this.actions))
        //
        // if (ticket.status === 4) {
        //   const answerIndex = actions[0].toolbar.map(elm => elm.id).indexOf('answerTicket')
        //   if (answerIndex > -1) {
        //     actions[0].toolbar.splice(answerIndex, 1)
        //   }
        // }
        // this.$store.dispatch('updateNavbarActions', actions[0])

        ticket.messages.forEach((message) => {
          const attaches = []
          let attachCount = 1
          message.attachments.forEach((attach) => {
            attaches.push({
              name: this.$t('tickets.general.labels.dynamicAttach', {number: attachCount}),
              link: this.$u.getAssetsUrl(attach)
            })
            attachCount++
          })

          const messageItem = {
            userAvatar: message.user && message.user.avatar ? this.$u.getAssetsUrl(message.user.avatar, 'h100,w100') : require('@/assets/images/man-avatar.png'),
            creator: message.user ? `${message.user.name || ''} ${message.user.family || ''}` : message.user_name,
            company: message.user ? message.user.role : message.user_role,
            body: message.message || '',
            client: !message.by_me,
            date: this.$u.convertUtcToLocale(message.sent_at, this.$u.locale.validator('moment.dateTime')).split(' ')[0],
            time: this.$u.convertUtcToLocale(message.sent_at, this.$u.locale.validator('moment.dateTime')).split(' ')[1],
            attaches
          }

          this.ticket.messages.push(messageItem)
        })

        this.$nextTick(() => {
          window.document.getElementById('showLastMessage').scrollIntoView()
        })
      })
    },
    handleReloadTicket () {
      this.ticket = {
        id: null,
        subject: '',
        department: '',
        status: 0,
        date: '',
        lastUpdate: '',
        messages: []
      }
      this.answerTicketPromptStatus = false
      this.getTicket()
    },

    sendMessageTicket () {
      sendTicketToService(this.$route.params.id).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('tickets.general.notifications.sendMessage.success'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.notifications.sendMessage.success')),
          color: 'success'
        })

        this.handleReloadTicket()
      })
        .catch((error) => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('others.alert.duplicateRequest.title'),
              text: this.$t('others.alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('others.alert.duplicateRequest.message')),
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('others.alert.error.title'),
              text: this.$t('tickets.general.notifications.sendMessage.error'),
              color: 'danger',
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('tickets.general.notifications.sendMessage.error'))
            })
          }
        })
    },

    completeTicket () {
      completeTicket(this.$route.params.id).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('tickets.general.notifications.complete.success'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.notifications.complete.success')),
          color: 'success'
        })

        this.handleReloadTicket()
      })
        .catch((error) => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('others.alert.duplicateRequest.title'),
              text: this.$t('others.alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('others.alert.duplicateRequest.message')),
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('others.alert.error.title'),
              text: this.$t('tickets.general.notifications.complete.error'),
              color: 'danger',
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('tickets.general.notifications.complete.error'))
            })
          }
        })
    }
    /*consoleLog (log) {
      console.log(log)
    }*/
  }
}
</script>

<style lang="scss">
  .ticket-detail {
    .vx-card__collapsible-content {
      .vx-card__body {
        padding: 0;
        display: flex;
        flex-direction: column;
      }
    }

    .ticket-detail-profile {
      flex-grow: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        display: block;
        border-radius: .2rem;
        width: 10px;
        background: #f9f9fd;
        right: 10px;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
        border-radius: .2rem;
        background: #cecece;
      }
    }
    .general-info {
      display: flex;
      border-bottom: 1px solid #cdcdcd;
      padding: 15px 15px 0;

      .general-info-items {
        width: 50%;

        &.left {
          .general-info-item {
            display: flex;
            justify-content: flex-end;
          }
        }

        .general-info-item {
          display: flex;
          line-height: 30px;

          .label {
            margin: 0 5px;
          }

          .content {
            color: #999999;

            &.date {
              direction: rtl;
            }
          }

          .complete-btn {
            padding: 5px 20px;
            margin-bottom: 10px;
            color: #ffffff;
            background-color: #4e7fe0;
            border: 1px solid #4e7fe0;
            border-radius: 5px;

            &:hover {
              cursor: pointer;
              background-color: #444E9C;
              border: 1px solid #444E9C;
            }

            &:focus {
              outline: none;
            }
          }
        }

        .subject {
          font-size: 17px;
          line-height: 30px;
        }
      }

      &.is-mobile {
        flex-direction: row;
        flex-wrap: wrap;
        padding: 5px 5px 0;

        .general-info-items {
          flex: 1;
          min-width: 200px;

          .subject,
          .general-info-item {
            line-height: 30px;

            .complete-btn {
              margin-bottom: 0;
            }
          }

          &.left {
            .general-info-item {
              justify-content: flex-start;

              .complete-btn {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .message-section {
      display: flex;
      flex-grow: 1;
      min-height: 130px;
      flex-direction: column-reverse;
      padding: 20px 15px;
      overflow-y: auto;

      .message {
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 10px;

        .user-avatar {
          height: 40px;
          width: 40px;

          .user-image {
            height: 100%;
            width: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .message-body {
          width: calc(100% - 110px);
          max-width: 500px;
          margin: 0 10px;
          padding: 15px;
          background-color: #4e7fe0;
          color: #ffffff;
          border-radius: 0.5rem 0 0.5rem 0.5rem;

          .message-header {
            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-start;
            font-size: 15px;
            color: #ffffff;
            margin-bottom: 20px;

            .user-name {
              margin: 0 5px;
            }

            .user-company {
              margin: 0 5px;
            }
          }

          .attach-list {
            margin-top: 20px;

            .attach-link {
              display: flex;
              align-items: center;
              color: inherit;

              .attach-name {
                margin: 0 10px;
              }
            }
          }
        }

        .message-date {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;
          width: 70px;

          .date,
          .time {
            white-space: nowrap;
          }
        }

        &.client {
          flex-direction: row;

          .message-body {
            border-radius: 0 0.5rem 0.5rem 0.5rem;
            background-color: #eff0f7;
            color: #000000;

            .message-header {
              color: #000000;
              text-align: left;
              flex-direction: row;
            }
          }

          .message-date {
            align-items: flex-start;
          }
        }
      }
    }
  }
</style>
